import axios from "axios";

// 获取设备信息
export function getInfo(query) {
  return axios.get("/energy/api/electricdevice/getDevice/" + query)
}

// 获取历史数据
export function getHistory(data) {
  return axios.post("/energy/api/eletrichisdata/getEcharts", data)
}



// WEBPACK FOOTER //
// ./src/api/electricity-api.js